import React from "react";
import composedTimesheetContainer from "../../../containers/TimeSheetContainer";
import Timesheet from "./TimeSheet";

const TimesheetMainComponent = (props) => {
  return <Timesheet />;
};

export default composedTimesheetContainer(TimesheetMainComponent);
